(function () {
  function parseStatValue(rawValue) {
    if (!rawValue) return null;

    const trimmed = String(rawValue).trim();
    const match = trimmed.match(/^([\d,.]+)\s*(.*)$/);

    if (!match) return null;

    const numeric = parseFloat(match[1].replace(/,/g, ''));
    if (Number.isNaN(numeric)) return null;

    return {
      end: numeric,
      suffix: match[2] || '',
      decimals: (match[1].split('.')[1] || '').length,
      display: trimmed,
    };
  }

  function formatStatValue(value, suffix, decimals) {
    const formatted =
      decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
    return `${formatted}${suffix}`;
  }

  function animateValue(element, parsed, duration) {
    const start = 0;
    const range = parsed.end - start;
    const startTime = performance.now();

    function step(currentTime) {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = start + range * eased;

      element.textContent = formatStatValue(current, parsed.suffix, parsed.decimals);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        element.textContent = parsed.display;
      }
    }

    requestAnimationFrame(step);
  }

  function initSection(section) {
    if (section.dataset.counterInitialized === 'true') return;
    section.dataset.counterInitialized = 'true';

    const counters = section.querySelectorAll('[data-survey-counter]');
    counters.forEach((counter) => {
      const parsed = parseStatValue(counter.dataset.surveyCounter);
      if (!parsed || parsed.end === 0) return;

      counter.textContent = formatStatValue(0, parsed.suffix, parsed.decimals);
      animateValue(counter, parsed, 1200);
    });
  }

  function setupObserver() {
    const sections = document.querySelectorAll(
      '.customer-survey-stats[data-enable-counter="true"]'
    );

    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(initSection);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          initSection(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.25 }
    );

    sections.forEach((section) => observer.observe(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.customer-survey-stats[data-enable-counter="true"]');
    if (section) initSection(section);
  });
})();
